import { Mutation } from 'graphql/generated/graphqlTypes';

export function mockedDeleteVisitorGroupData(
  deleteVisitorGroupById: string | null
): Pick<Mutation, 'deleteVisitorGroupById'> {
  return {
    deleteVisitorGroupById
  };
}

export const mockedDeleteVisitorGroupDataForMutation = mockedDeleteVisitorGroupData('mockedVisitorGroupId1');
